import React, { useState, useRef, useEffect } from "react";

const AlertBox = (props) => {
  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  if (!props.text) {
    return null;
  }

  const trimmedText = props.text.replace(
    /<p class="MsoNormal">&nbsp;<\/p>/g,
    ""
  );

  return props.size < 960 ? (
    <div>
      <div
        style={{
          border: "1px solid #8b2640",
          padding: "10px 0 0",
          backgroundColor: "white",
          overflow: "hidden",
        }}
      >
        <p
          style={{
            margin: "0 10px 10px 10px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: showDetails ? "pre-line" : "nowrap",
            maxHeight: showDetails ? "none" : "20px",
          }}
          dangerouslySetInnerHTML={{ __html: trimmedText }}
        />
        <div
          style={{
            backgroundColor: "#8b2640",
            textAlign: "center",
            padding: "5px 0",
          }}
        >
          <button
            onClick={toggleDetails}
            style={{
              color: "#fff",
              fontWeight: "600",
            }}
          >
            {showDetails ? "Скрыть" : "Читать далее"}
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div
      style={{
        border: "1px solid #8b2640",
        padding: "10px 0 0",
        backgroundColor: "white",
      }}
    >
      <p
        style={{ margin: "0px 10px 10px 10px" }}
        dangerouslySetInnerHTML={{ __html: trimmedText }}
      />
    </div>
  );
};

export default AlertBox;
